import { Alert, Flex } from "@mantine/core";
import { useEffect, useState } from "react";
import type { ChatVariant } from "../ChatQueue/variants";
import classes from "./ChatAlertBanner.module.css";
import { chatAlertBannerConfig } from "./chatAlertBannerConfig";

export const ChatAlertBanner = ({ variant }: { variant: ChatVariant }) => {
    const [visible, setVisible] = useState(true);
    const config = chatAlertBannerConfig[variant];

    // biome-ignore lint/correctness/useExhaustiveDependencies: fix later
    useEffect(() => {
        setVisible(true);
    }, [variant]);

    if (!config || !visible) return null;

    return (
        <Flex mb="md" w="100%" wrap="wrap">
            <Alert
                icon={config.icon}
                color={config.color}
                title={config.title}
                withCloseButton={config.showClose}
                onClose={() => setVisible(false)}
                classNames={{
                    title: classes.title,
                    message: classes.description,
                }}
                styles={{
                    closeButton: {
                        color: config.closeButtonColor,
                    },
                }}
                w="100%"
            >
                {config.description}
            </Alert>
        </Flex>
    );
};
